export default function Logo({ className = "h-12" }) {
    return (
        <span className="inline-flex items-center" data-testid="payme-logo">
            <img
                src="/payme-logo.png"
                alt="PayMe"
                className={`${className} w-auto select-none`}
                draggable="false"
            />
        </span>
    );
}
